<template>
    <div class="application-header">
        <div class="logo">
            <icon name="astra-bookmark" />
            <span class="owner"><strong>ASTRA</strong>/</span><span class="application">Opgavestyring</span>
        </div>
        <div class="user" v-clickoutside="handleClose">
            <button type="button" @click="toggleMenu()">
                <div class="user-image">
                    <icon name="user" />
                </div>
                <div class="user-info show-for-medium">
                    <div class="user-info-name">{{ userInfo.name }}</div>
                    <div class="user-info-organization">{{ selectedOrganization.name }}</div>
                </div>
            </button>

            <div class="user-controls" :class="{ 'js-show': showMenu }">
                <div class="user-info show-for-small-only">
                    <div class="user-info-name">{{ userInfo.name }}</div>
                    <div class="user-info-organization">{{ selectedOrganization.name }}</div>
                </div>
                <ul>
                    <li v-if="facilityEndpoint" class="show-for-medium">
                        <a :href="facilityEndpoint" target="_blank">Gå til Anl&aelig;gsregister</a>
                    </li>
                    <li v-if="portalEndpoint" class="show-for-medium">
                        <a :href="portalEndpoint" target="_blank">Gå til Administration</a>
                    </li>
                    <li>
                        <button data-toggle="user-dropdown" @click="signOut()">
                            Log ud
                            <icon name="log-out" class="smaller-svg" />
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import clickoutside from './../../../mixins/shared/clickoutside.js'

export default {
    name: 'applicationHeader',
    directives: {
        clickoutside
    },
    data () {
        return {
            name: null,
            orgId: null,
            showMenu: false
        }
    },
    computed: {
        ...mapGetters({
            userInfo: 'userInfo',
            selectedOrganization: 'getSelectedOrganization',
            facilityEndpoint: 'getFacilityEndpoint',
            portalEndpoint: 'getPortalEndpoint'
        })
    },
    methods: {
        ...mapActions({
            onSignOut: 'signOut'
        }),
        signOut () {
            this.onSignOut().then((response) => {
                let workLink = this.$router.resolve({ name: 'login' })
                window.location = workLink.href
            })
        },
        toggleMenu () {
            this.showMenu = !this.showMenu
        },
        handleClose () {
            if (this.showMenu) {
                this.toggleMenu()
            }
        }
    }
}
</script>

<style lang="scss">
@import '../../../scss/components/application-header.scss';
</style>



// WEBPACK FOOTER //
// src/components/shared/header/application-header.vue